import { Button, ButtonProps, Spinner } from "@chakra-ui/react";
import { forwardRef } from "react";

/**
 * A primary action that stays focused while its request runs: `isLoading` would
 * disable the button and drop focus to the body. The caller ignores presses
 * while busy. Busy keeps the full label contrast, because the label and spinner
 * are the only progress cue, and the same width: the spinner sits in the left
 * padding, out of the layout.
 */
const BusyButton = forwardRef<HTMLButtonElement, ButtonProps & { isBusy: boolean }>(
  ({ isBusy, children, ...rest }, ref) => (
    <Button
      ref={ref}
      colorScheme="blue"
      aria-busy={isBusy}
      aria-disabled={isBusy}
      _disabled={{ opacity: 1, cursor: "progress" }}
      {...rest}
    >
      {isBusy && (
        <Spinner size="xs" position="absolute" left={1} aria-hidden="true" />
      )}
      {children}
    </Button>
  )
);

BusyButton.displayName = "BusyButton";

export default BusyButton;
